import React from 'react';

/**
 * Lazy Loaded Components
 * These components are only loaded when needed (admin/owner users)
 * This keeps their code out of the main bundle for better security & performance
 */

// Settings component - Lazy loaded (only for admin/owner users)
export const Settings = React.lazy(() => import('../Settings/Settings'));

// Groups component - Lazy loaded (only for admin/owner users)
export const Groups = React.lazy(() => import('../Groups/Groups'));

// Users Management component - Lazy loaded (only for admin/owner users)
export const UsersManagement = React.lazy(
  () => import('../UsersManagement/UsersManagement')
);

// Theme & Logo component - Lazy loaded (only for admin/owner users)
export const ThemeAndLogo = React.lazy(
  () => import('../ThemeAndLogo/ThemeAndLogo')
);

// Configuration Management component - Lazy loaded (only for admin/owner users)
export const ConfigurationManagement = React.lazy(
  () => import('../Settings/ConfigurationManagement')
);
